module.exports = __webpack_public_path__ + "static/img/03.26c6e95b.png";